import styled from 'styled-components'

export const SpinnerWrapper = styled.div`
  height: 64px;
  width: 64px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;
`

export const LoadingContentWrapper = styled.div`
  height: ${(p) => {
    return p.height
  }};
  width: ${(p) => {
    return p.width
  }};
  position: absolute;
  z-index: 55;
  background: rgba(255, 255, 255, 0.5);
  top: 0;
  left: 0;
  display: ${(p) => {
    return p.active
  }};
  justify-content: center;
  align-items: center;
`
